import { useContext, useState } from "react"
import { httpPost } from "../services/Http.service"
import { apiUrl } from "../configs/config.constants"
import { AxiosResponse } from "axios"
import { User } from "../types/user.type"
import { toast } from "react-toastify"
import { DataContext } from "../App"

export function useLogin() {
  const [isLoading, setIsLoading] = useState(false)
  const [loginUser, setLoginUser] = useState<User | null>(null)
  const [modalState, setModalState] = useState<'login' | 'changePassword'>('login')
  const { setCustomer } = useContext(DataContext)

  async function login(username: string, password: string) {
    setIsLoading(true)

    httpPost(apiUrl.login, { username, password })
      .then((response: AxiosResponse<{ user: User, accessToken: string }>) => {
        setIsLoading(false)
        setLoginUser(response.data.user)
        setCustomer(response.data.user)
        localStorage.setItem('customer.user', JSON.stringify(response.data.user))
        localStorage.setItem('customer.accessToken', response.data.accessToken)
      })
      .catch((error: any) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  async function changePassword(username: string, password: string) {
    setIsLoading(true)

    httpPost(apiUrl.firstTimeLogin, { username, password })
      .then((response: AxiosResponse) => {
        setIsLoading(false)
        setModalState('login')
        toast.success('Password changed successfully')
      })
      .catch((error: any) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  return {
    loginUser,
    login,
    changePassword,
    isLoading,
    modalState,
    setModalState,
  }

}
